import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { OverflowDisplayTooltip } from "@/components/ui/Tooltip/OverflowDisplayTooltip";

interface GroupCardProps {
  title: string;
  description?: string;
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
  version?: number;
  to?: string;
}

const CardContent = ({ title, description, version, children }: GroupCardProps) => (
  <>
    <div className="pointer-events-none flex items-center justify-between">
      <OverflowDisplayTooltip content={title}>
        <h3 className="truncate break-words text-base font-medium text-gray-800" title={title}>
          {title}
        </h3>
      </OverflowDisplayTooltip>
      {version !== undefined && (
        <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
          v{version}
        </span>
      )}
    </div>
    {description && (
      <p className="mt-2 line-clamp-2 break-words text-sm leading-relaxed text-gray-600">
        {description}
      </p>
    )}
    <div className="overflow-hidden">{children}</div>
  </>
);

const GroupCard = ({
  title,
  description,
  onClick,
  children,
  className = "",
  version,
  to,
}: GroupCardProps) => {
  const cardClassName = `flex h-full cursor-pointer flex-col justify-center rounded-sm border border-gray-200 bg-white p-5 transition-colors duration-200 ease-in-out hover:bg-gray-50 ${className}`;

  if (to) {
    return (
      <Link to={to} className={cardClassName} onClick={onClick}>
        <CardContent title={title} description={description} version={version}>
          {children}
        </CardContent>
      </Link>
    );
  }

  return (
    <div className={cardClassName} onClick={onClick}>
      <CardContent title={title} description={description} version={version}>
        {children}
      </CardContent>
    </div>
  );
};

export default GroupCard;
